import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed } from 'vue'
import { logout } from '@/store/logoutActions'
import { getStateData } from '@/store'
import { languages, translate } from '@/services/i18n'
import { operationsService } from '@/services/operationsService'
import { translationProvider } from '@/services/translationProvider'
import { SHOW_LANGUAGE_PICKER } from '@/common/config'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMenu',
  props: {
  mobileMode: Boolean,
},
  emits: ['select-language'],
  setup(__props, { emit: __emit }) {



const emit = __emit

const userPicture = computed(() => getStateData().user?.picture || null)

const userName = computed(
  () => getStateData().user?.fullNameWithoutTitle || 'Unknown name'
)

const roleName = computed(() => {
  return (
    getStateData()
      .user?.roles?.map((role) => role.name)
      .join(' | ') || 'Unknown role'
  )
})

async function onLanguageChange(evt: Event) {
  const { detail } = evt as CustomEvent<string>
  translationProvider.set(detail, {
    updated: async () => {
      await operationsService.changeUserLanguage(detail)
      emit('select-language')
    },
  })
}

async function onLogout() {
  await logout()
}

return (_ctx: any,_cache: any) => {
  const _component_dsf_navbar_item = _resolveComponent("dsf-navbar-item")!
  const _component_dsf_nav_menu = _resolveComponent("dsf-nav-menu")!

  return (_openBlock(), _createBlock(_component_dsf_nav_menu, {
    dsf_name: userName.value,
    dsf_role: roleName.value,
    dsf_mobile: __props.mobileMode,
    dsf_profile_url: userPicture.value
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" Language selector "),
      (_unref(SHOW_LANGUAGE_PICKER))
        ? (_openBlock(), _createBlock(_component_dsf_navbar_item, {
            key: 0,
            dsf_light: "",
            dsf_icon: "Globe",
            dsf_title: _unref(translate)('profile.language'),
            dsf_id: "language",
            onNavigate: _withModifiers(onLanguageChange, ["stop"])
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (lang) => {
                return (_openBlock(), _createBlock(_component_dsf_navbar_item, {
                  key: lang.key,
                  dsf_title: _unref(translate)(lang.key),
                  dsf_selected: lang.value === _unref(translationProvider).currentLanguage,
                  dsf_id: lang.value
                }, null, 8 /* PROPS */, ["dsf_title", "dsf_selected", "dsf_id"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["dsf_title"]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Logout "),
      _createVNode(_component_dsf_navbar_item, {
        dsf_light: "",
        dsf_icon: "LogOut",
        dsf_title: _unref(translate)('profile.logout'),
        dsf_id: "logout",
        onNavigate: _withModifiers(onLogout, ["stop"])
      }, null, 8 /* PROPS */, ["dsf_title"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["dsf_name", "dsf_role", "dsf_mobile", "dsf_profile_url"]))
}
}

})